// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Premium design tokens for Peripherals Settings */
:root {
  --periph-bg: #f8fafc;
  --periph-card-bg: #ffffff;
  --periph-border: #e2e8f0;
  --periph-text-primary: #0f172a;
  --periph-text-secondary: #c70036;
  --periph-text-muted: #ff2056;

  --periph-icon-bg-connected: #ecfdf5;
  --periph-icon-text-connected: #059669;
  --periph-icon-bg-disconnected: #f1f5f9;
  --periph-icon-text-disconnected: #64748b;

  --periph-status-text-connected: #047857;

  --periph-btn-setup-border: #e2e8f0;
  --periph-btn-setup-bg: #ffffff;
  --periph-btn-setup-text: #334155;
  --periph-btn-setup-hover-bg: #f8fafc;
  --periph-btn-setup-hover-text: #0f172a;

  --periph-scan-bg: #0f172a;
  --periph-scan-text: #ffffff;
  --periph-scan-hover-bg: #1e293b;

  --periph-header-bg: #ffffff;
  --periph-header-border: #e2e8f0;
}

body.dark,
.dark {
  --periph-bg: #0b0f19;
  --periph-card-bg: #1e293b;
  --periph-border: #334155;
  --periph-text-primary: #f8fafc;
  --periph-text-secondary: #94a3b8;
  --periph-text-muted: #64748b;

  --periph-icon-bg-connected: #064e3b;
  --periph-icon-text-connected: #34d399;
  --periph-icon-bg-disconnected: #334155;
  --periph-icon-text-disconnected: #94a3b8;

  --periph-status-text-connected: #34d399;

  --periph-btn-setup-border: #334155;
  --periph-btn-setup-bg: #1e293b;
  --periph-btn-setup-text: #cbd5e1;
  --periph-btn-setup-hover-bg: #334155;
  --periph-btn-setup-hover-text: #f8fafc;

  --periph-scan-bg: #f8fafc;
  --periph-scan-text: #0f172a;
  --periph-scan-hover-bg: #e2e8f0;

  --periph-header-bg: #1e293b;
  --periph-header-border: #334155;
}

/* Container & Font */
.peripherals-page-container {
  height: calc(100vh - 54px);
  overflow-y: scroll; /* Force scrollbar */
  background-color: var(--periph-bg);
  color: var(--periph-text-primary);
  font-family:
    "Inter",
    -apple-system,
    BlinkMacSystemFont,
    "Segoe UI",
    Roboto,
    sans-serif;
  padding-bottom: 6rem;
  transition:
    background-color 0.3s ease,
    color 0.3s ease;
  margin-top: 54px;
  width: 100%;
}

.peripherals-page-container::-webkit-scrollbar {
  width: 8px;
  display: block;
}

.peripherals-page-container::-webkit-scrollbar-track {
  background: #f1f1f1;
}

.peripherals-page-container::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 4px;
}

.peripherals-page-container::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

/* Header */
.peripherals-header {
  background-color: var(--periph-header-bg);
  border-bottom: 1px solid var(--periph-header-border);
  position: sticky;
  top: 0;
  z-index: 100;
  box-shadow: 0 4px 20px -10px rgba(0, 0, 0, 0.05);
  transition:
    background-color 0.3s ease,
    border-color 0.3s ease;
}

.peripherals-header-content {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 1.5rem;
  height: 72px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.peripherals-header-left {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.peripherals-back-btn {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: var(--periph-btn-setup-hover-bg);
  border: 1px solid var(--periph-border);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  color: #45556c;
}

.peripherals-back-btn:hover {
  background-color: var(--periph-border);
  color: var(--periph-text-primary);
}

.peripherals-title {
  font-size: 1.25rem;
  font-weight: 700;
  letter-spacing: -0.025em;
  margin: 0;
  color: var(--periph-text-primary);
}

.peripherals-scan-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  height: 40px;
  padding: 0 1.25rem;
  border-radius: 18px;
  font-size: 0.875rem;
  font-weight: 600;
  background-color: var(--periph-scan-bg);
  color: var(--periph-scan-text);
  border: none;
  cursor: pointer;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  transition: all 0.2s ease;
}

.peripherals-scan-btn:hover {
  background-color: var(--periph-scan-hover-bg);
  transform: translateY(-1px);
}

.peripherals-scan-btn:active {
  transform: translateY(0);
}
/* Main Content Area */
.peripherals-main {
  max-width: 1200px;
  margin: 0 auto;
  padding: 2rem 1.5rem;
}

.peripherals-category-select-wrapper {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 2rem;
}

.category-select-wrapper {
  width: 280px !important;
}

/* Responsive Card Grid */
.peripherals-grid {
  display: grid;
  grid-template-columns: repeat(1, minmax(0, 1fr));
  gap: 1.25rem;
}

@media (min-width: 640px) {
  .peripherals-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (min-width: 1024px) {
  .peripherals-grid {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}

@media (min-width: 1280px) {
  .peripherals-grid {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }
}

/* Peripherals Cards */
.peripherals-card {
  background-color: var(--periph-card-bg);
  border-radius: 1rem;
  padding: 1.25rem;
  border: 1px solid var(--periph-border);
  box-shadow:
    0 1px 3px rgba(0, 0, 0, 0.02),
    0 1px 2px rgba(0, 0, 0, 0.04);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 240px;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
}

.peripherals-card:hover {
  transform: translateY(-4px);
  box-shadow:
    0 10px 20px -5px rgba(0, 0, 0, 0.05),
    0 4px 6px -2px rgba(0, 0, 0, 0.02);
}

.peripherals-card.active {
  border-color: var(--periph-icon-text-connected);
  box-shadow: 0 0 0 2px var(--periph-icon-bg-connected);
}

.peripherals-card-top {
  margin-bottom: 1rem;
}

.peripherals-card-header-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 0.75rem;
}

.peripherals-icon-box {
  width: 40px;
  height: 40px;
  border-radius: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
}

.peripherals-icon-box.connected {
  background-color: var(--periph-icon-bg-connected);
  color: var(--periph-icon-text-connected);
}

.peripherals-icon-box.disconnected {
  background-color: var(--periph-icon-bg-disconnected);
  color: var(--periph-icon-text-disconnected);
}

.peripherals-card-title {
  font-size: 1rem;
  font-weight: 700;
  color: var(--periph-text-primary);
  margin: 0 0 0.25rem 0;
  line-height: 1.4;
}

.peripherals-card-model {
  font-size: 0.75rem;
  color: #62748e;
  margin: 0;
}

.peripherals-card-bottom {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.peripherals-status-row {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.status-icon {
  width: 1rem;
  height: 1rem;
}

.status-icon.connected {
  color: var(--periph-icon-text-connected);
}

.status-icon.disconnected {
  color: var(--periph-text-muted);
}

.peripherals-status-text {
  font-size: 0.8125rem;
  font-weight: 600;
}

.peripherals-status-text.connected {
  color: var(--periph-status-text-connected);
}

.peripherals-status-text.disconnected {
  color: var(--periph-text-secondary);
}

.peripherals-last-active {
  font-size: 0.6875rem;
  font-weight: 500;
  color: #90a1b9;
}

.peripherals-card-actions {
  border-top: 1px solid var(--periph-border);
  padding-top: 0.75rem;
  display: flex;
  gap: 0.5rem;
}

.peripherals-setup-btn,
.peripherals-test-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.375rem;
  height: 32px;
  flex: 1;
  border-radius: 20px;
  font-size: 0.75rem;
  font-weight: 600;
  background-color: var(--periph-btn-setup-bg);
  border: 1px solid var(--periph-btn-setup-border);
  color: var(--periph-btn-setup-text);
  cursor: pointer;
  transition: all 0.2s ease;
}

.peripherals-setup-btn:hover,
.peripherals-test-btn:hover {
  background-color: var(--periph-btn-setup-hover-bg);
  color: var(--periph-btn-setup-hover-text);
}

.peripherals-setup-btn svg,
.peripherals-test-btn svg {
  color: #62748e;
  transition: color 0.2s ease;
}

.peripherals-setup-btn:hover svg,
.peripherals-test-btn:hover svg {
  color: var(--periph-btn-setup-hover-text);
}

.peripherals-setup-btn:disabled,
.peripherals-test-btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

/* ── Setup Modal ── */
.periph-modal-overlay {
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.45);
  z-index: 1300;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
}

.periph-modal {
  background-color: #ffffff;
  border-radius: 20px;
  width: 100%;
  max-width: 480px;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  overflow: hidden;
  position: relative;
  animation: periph-modal-in 0.2s ease;
}

@keyframes periph-modal-in {
  from {
    opacity: 0;
    transform: scale(0.96) translateY(6px);
  }
  to {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}

.periph-modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1.25rem 1.5rem 1rem;
  border-bottom: 1px solid #f1f5f9;
}

.periph-modal-title {
  font-size: 1.125rem;
  font-weight: 700;
  color: #0f172a;
  margin: 0;
  letter-spacing: -0.02em;
}

.periph-modal-close-btn {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  border: none;
  background: transparent;
  color: #64748b;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition:
    background-color 0.15s ease,
    color 0.15s ease;
}

.periph-modal-close-btn:hover {
  background-color: #f1f5f9;
  color: #0f172a;
}

.periph-modal-body {
  padding: 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
}

.periph-modal-field {
  display: flex;
  flex-direction: column;
  gap: 0.625rem;
}

.periph-modal-label {
  font-size: 0.8125rem;
  font-weight: 600;
  color: #334155;
}

/* Connection type buttons */
.periph-conn-type-grid {
  display: flex;
  gap: 0.75rem;
  flex-wrap: wrap;
}

.periph-conn-type-btn {
  flex: 1;
  min-width: 100px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 0.875rem 0.5rem;
  border-radius: 12px;
  border: 2px solid #e2e8f0;
  background-color: #ffffff;
  color: #64748b;
  cursor: pointer;
  transition:
    border-color 0.15s ease,
    background-color 0.15s ease,
    color 0.15s ease;
}

.periph-conn-type-btn:hover {
  border-color: #cbd5e1;
  background-color: #f8fafc;
}

.periph-conn-type-btn.active {
  border-color: #2563eb;
  background-color: #eff6ff;
  color: #1d4ed8;
}

.periph-conn-type-btn:disabled {
  opacity: 0.35;
  cursor: not-allowed;
}

.periph-conn-type-label {
  font-size: 0.75rem;
  font-weight: 600;
}

/* Modal action buttons */
.periph-modal-actions {
  display: flex;
  gap: 0.75rem;
  padding-top: 0.5rem;
}

.periph-modal-cancel-btn,
.periph-modal-connect-btn {
  flex: 1;
  height: 44px;
  border-radius: 12px;
  font-size: 0.875rem;
  font-weight: 600;
  cursor: pointer;
  transition:
    background-color 0.15s ease,
    opacity 0.15s ease;
}

.periph-modal-cancel-btn {
  border: 1px solid #e2e8f0;
  background-color: #ffffff;
  color: #334155;
}

.periph-modal-cancel-btn:hover {
  background-color: #f8fafc;
}

.periph-modal-connect-btn {
  border: none;
  background-color: #2563eb;
  color: #ffffff;
}

.periph-modal-connect-btn:hover:not(:disabled) {
  background-color: #1d4ed8;
}

.periph-modal-connect-btn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.periph-view-more-btn {
  background: none;
  border: none;
  color: #2563eb;
  font-size: 0.8125rem;
  font-weight: 600;
  cursor: pointer;
  padding: 0;
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  transition: color 0.15s ease;
}

.periph-view-more-btn:hover {
  color: #1d4ed8;
  text-decoration: underline;
}

body.dark .periph-view-more-btn,
.dark .periph-view-more-btn {
  color: #3b82f6;
}

body.dark .periph-view-more-btn:hover,
.dark .periph-view-more-btn:hover {
  color: #60a5fa;
}

/* Instructions section within the setup modal */
.periph-modal-instructions {
  background-color: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 1rem 1.25rem;
  max-height: 300px;
  overflow-y: auto;
}

.periph-modal-instructions-title {
  font-size: 0.8125rem;
  font-weight: 700;
  color: #0f172a;
  margin: 0 0 0.75rem 0;
  text-transform: uppercase;
  letter-spacing: 0.02em;
}

.periph-modal-instructions-content {
  font-size: 0.8125rem;
  color: #475569;
  line-height: 1.6;
}

.periph-modal-instructions-content ul {
  margin: 0;
  padding-left: 1.25rem;
}

.periph-modal-instructions-content li {
  margin-bottom: 0.5rem;
}

.periph-modal-instructions-content a {
  color: #2563eb;
  text-decoration: underline;
}

.periph-modal-instructions-content img {
  border-radius: 8px;
  margin: 0.5rem 0;
}

/* Advanced Settings Section */
.periph-adv-settings-box {
  margin-top: 2.5rem;
  background-color: var(--periph-card-bg);
  border-radius: 1.5rem;
  padding: 2rem;
  border: 1px solid var(--periph-border);
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.03);
  transition: all 0.3s ease;
  opacity: 0.6;
  cursor: not-allowed;
}

.periph-adv-settings-box * {
  cursor: not-allowed !important;
}

.periph-adv-settings-header {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 2rem;
}

.periph-adv-settings-icon-box {
  padding: 0.5rem;
  background-color: var(--periph-icon-bg-disconnected);
  border-radius: 0.5rem;
  color: #64748b;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
}

body.dark .periph-adv-settings-icon-box,
.dark .periph-adv-settings-icon-box {
  color: #94a3b8;
}

.periph-adv-settings-title-container {
  display: flex;
  flex-direction: column;
}

.periph-adv-settings-title {
  font-size: 1.25rem;
  font-weight: 700;
  letter-spacing: -0.025em;
  color: var(--periph-text-primary);
  margin: 0;
}

.periph-adv-settings-subtitle {
  font-size: 0.875rem;
  color: #64748b;
  margin: 0.25rem 0 0 0;
  transition: color 0.3s ease;
}

body.dark .periph-adv-settings-subtitle,
.dark .periph-adv-settings-subtitle {
  color: #94a3b8;
}

.periph-adv-settings-content {
  max-width: 48rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.periph-adv-settings-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1.25rem;
  background-color: var(--periph-bg);
  border-radius: 1rem;
  border: 1px solid var(--periph-border);
  transition: all 0.2s ease;
}

.periph-adv-settings-row:hover {
  border-color: #cbd5e1;
}

body.dark .periph-adv-settings-row:hover,
.dark .periph-adv-settings-row:hover {
  border-color: #475569;
}

.periph-adv-settings-info {
  padding-right: 1.5rem;
}

.periph-adv-settings-item-title {
  font-size: 0.9375rem;
  font-weight: 600;
  color: var(--periph-text-primary);
  margin: 0;
}

.periph-adv-settings-item-desc {
  font-size: 0.8125rem;
  color: #64748b;
  margin: 0.25rem 0 0 0;
  line-height: 1.4;
  transition: color 0.3s ease;
}

body.dark .periph-adv-settings-item-desc,
.dark .periph-adv-settings-item-desc {
  color: #94a3b8;
}

.periph-switch-btn {
  display: inline-flex;
  height: 1.25rem;
  width: 2.25rem;
  flex-shrink: 0;
  cursor: pointer;
  align-items: center;
  border-radius: 9999px;
  border: 2px solid transparent;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  transition: background-color 0.2s ease;
  background-color: #cbd5e1;
  position: relative;
  padding: 0;
  margin-top: 0.25rem;
}

.periph-switch-btn[data-state="checked"] {
  background-color: #2563eb;
}

body.dark .periph-switch-btn {
  background-color: #475569;
}

body.dark .periph-switch-btn[data-state="checked"] {
  background-color: #3b82f6;
}

.periph-switch-thumb {
  pointer-events: none;
  display: block;
  height: 1rem;
  width: 1rem;
  border-radius: 9999px;
  background-color: #ffffff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: transform 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  transform: translateX(0);
}

/* ── Dark mode: modal surfaces ── */
.dark .periph-modal {
  background-color: #1e293b;
  color: #f1f5f9;
}

.dark .periph-modal-header {
  border-bottom-color: #334155;
}

.dark .periph-modal-title {
  color: #f1f5f9;
}

.dark .periph-modal-close-btn {
  color: #94a3b8;
}

.dark .periph-modal-close-btn:hover {
  background-color: #334155;
  color: #f1f5f9;
}

.dark .periph-modal-label {
  color: #94a3b8;
}

.dark .periph-conn-type-btn {
  background-color: #1e293b;
  border-color: #334155;
  color: #94a3b8;
}

.dark .periph-conn-type-btn:hover {
  background-color: #334155;
  border-color: #475569;
}

.dark .periph-conn-type-btn.active {
  background-color: #1e3a5f;
  border-color: #3b82f6;
  color: #93c5fd;
}

.dark .periph-modal-cancel-btn {
  background-color: #1e293b;
  border-color: #334155;
  color: #cbd5e1;
}

.dark .periph-modal-cancel-btn:hover {
  background-color: #334155;
}

.dark .periph-modal-instructions {
  background-color: #0f172a;
  border-color: #334155;
}

.dark .periph-modal-instructions-title {
  color: #f1f5f9;
}

.dark .periph-modal-instructions-content {
  color: #94a3b8;
}

.periph-switch-thumb[data-state="checked"] {
  transform: translateX(1rem);
}
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/product/settings/components/Peripherals/index.css"],"names":[],"mappings":"AAAA,mDAAmD;AACnD;EACE,oBAAoB;EACpB,yBAAyB;EACzB,wBAAwB;EACxB,8BAA8B;EAC9B,gCAAgC;EAChC,4BAA4B;;EAE5B,mCAAmC;EACnC,qCAAqC;EACrC,sCAAsC;EACtC,wCAAwC;;EAExC,uCAAuC;;EAEvC,kCAAkC;EAClC,8BAA8B;EAC9B,gCAAgC;EAChC,oCAAoC;EACpC,sCAAsC;;EAEtC,yBAAyB;EACzB,2BAA2B;EAC3B,+BAA+B;;EAE/B,2BAA2B;EAC3B,+BAA+B;AACjC;;AAEA;;EAEE,oBAAoB;EACpB,yBAAyB;EACzB,wBAAwB;EACxB,8BAA8B;EAC9B,gCAAgC;EAChC,4BAA4B;;EAE5B,mCAAmC;EACnC,qCAAqC;EACrC,sCAAsC;EACtC,wCAAwC;;EAExC,uCAAuC;;EAEvC,kCAAkC;EAClC,8BAA8B;EAC9B,gCAAgC;EAChC,oCAAoC;EACpC,sCAAsC;;EAEtC,yBAAyB;EACzB,2BAA2B;EAC3B,+BAA+B;;EAE/B,2BAA2B;EAC3B,+BAA+B;AACjC;;AAEA,qBAAqB;AACrB;EACE,0BAA0B;EAC1B,kBAAkB,EAAE,oBAAoB;EACxC,kCAAkC;EAClC,iCAAiC;EACjC;;;;;;cAMY;EACZ,oBAAoB;EACpB;;mBAEiB;EACjB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,WAAW;AACX;EACE,yCAAyC;EACzC,oDAAoD;EACpD,gBAAgB;EAChB,MAAM;EACN,YAAY;EACZ,gDAAgD;EAChD;;0BAEwB;AAC1B;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kDAAkD;EAClD,sCAAsC;EACtC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,sCAAsC;EACtC,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,SAAS;EACT,iCAAiC;AACnC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,uCAAuC;EACvC,8BAA8B;EAC9B,YAAY;EACZ,eAAe;EACf,yCAAyC;EACzC,yBAAyB;AAC3B;;AAEA;EACE,6CAA6C;EAC7C,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;AACA,sBAAsB;AACtB;EACE,iBAAiB;EACjB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,gDAAgD;EAChD,YAAY;AACd;;AAEA;EACE;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE;IACE,gDAAgD;EAClD;AACF;;AAEA,sBAAsB;AACtB;EACE,uCAAuC;EACvC,mBAAmB;EACnB,gBAAgB;EAChB,sCAAsC;EACtC;;iCAE+B;EAC/B,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,iBAAiB;EACjB,kDAAkD;AACpD;;AAEA;EACE,2BAA2B;EAC3B;;sCAEoC;AACtC;;AAEA;EACE,+CAA+C;EAC/C,qDAAqD;AACvD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,iDAAiD;EACjD,wCAAwC;AAC1C;;AAEA;EACE,oDAAoD;EACpD,2CAA2C;AAC7C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iCAAiC;EACjC,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,0CAA0C;EAC1C,oBAAoB;EACpB,aAAa;EACb,WAAW;AACb;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,YAAY;EACZ,OAAO;EACP,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,4CAA4C;EAC5C,gDAAgD;EAChD,mCAAmC;EACnC,eAAe;EACf,yBAAyB;AAC3B;;AAEA;;EAEE,kDAAkD;EAClD,yCAAyC;AAC3C;;AAEA;;EAEE,cAAc;EACd,2BAA2B;AAC7B;;AAEA;;EAEE,yCAAyC;AAC3C;;AAEA;;EAEE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE,eAAe;EACf,QAAQ;EACR,qCAAqC;EACrC,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,iDAAiD;EACjD,gBAAgB;EAChB,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE;IACE,UAAU;IACV,sCAAsC;EACxC;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,4BAA4B;EAC5B,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf;;oBAEkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;AAChB;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,OAAO;EACP,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,wBAAwB;EACxB,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf;;;oBAGkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;AACrB;;AAEA;;EAEE,OAAO;EACP,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf;;sBAEoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,UAAU;EACV,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA,gDAAgD;AAChD;EACE,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,8BAA8B;AAC9B;EACE,kBAAkB;EAClB,uCAAuC;EACvC,qBAAqB;EACrB,aAAa;EACb,sCAAsC;EACtC,0CAA0C;EAC1C,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,oDAAoD;EACpD,qBAAqB;EACrB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,iCAAiC;EACjC,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;EAChB,kCAAkC;EAClC,mBAAmB;EACnB,sCAAsC;EACtC,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,iCAAiC;EACjC,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,cAAc;EACd,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,qBAAqB;EACrB,6BAA6B;EAC7B,yCAAyC;EACzC,sCAAsC;EACtC,yBAAyB;EACzB,kBAAkB;EAClB,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,YAAY;EACZ,WAAW;EACX,qBAAqB;EACrB,yBAAyB;EACzB,wCAAwC;EACxC,uDAAuD;EACvD,wBAAwB;AAC1B;;AAEA,oCAAoC;AACpC;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,2BAA2B;AAC7B","sourcesContent":["/* Premium design tokens for Peripherals Settings */\n:root {\n  --periph-bg: #f8fafc;\n  --periph-card-bg: #ffffff;\n  --periph-border: #e2e8f0;\n  --periph-text-primary: #0f172a;\n  --periph-text-secondary: #c70036;\n  --periph-text-muted: #ff2056;\n\n  --periph-icon-bg-connected: #ecfdf5;\n  --periph-icon-text-connected: #059669;\n  --periph-icon-bg-disconnected: #f1f5f9;\n  --periph-icon-text-disconnected: #64748b;\n\n  --periph-status-text-connected: #047857;\n\n  --periph-btn-setup-border: #e2e8f0;\n  --periph-btn-setup-bg: #ffffff;\n  --periph-btn-setup-text: #334155;\n  --periph-btn-setup-hover-bg: #f8fafc;\n  --periph-btn-setup-hover-text: #0f172a;\n\n  --periph-scan-bg: #0f172a;\n  --periph-scan-text: #ffffff;\n  --periph-scan-hover-bg: #1e293b;\n\n  --periph-header-bg: #ffffff;\n  --periph-header-border: #e2e8f0;\n}\n\nbody.dark,\n.dark {\n  --periph-bg: #0b0f19;\n  --periph-card-bg: #1e293b;\n  --periph-border: #334155;\n  --periph-text-primary: #f8fafc;\n  --periph-text-secondary: #94a3b8;\n  --periph-text-muted: #64748b;\n\n  --periph-icon-bg-connected: #064e3b;\n  --periph-icon-text-connected: #34d399;\n  --periph-icon-bg-disconnected: #334155;\n  --periph-icon-text-disconnected: #94a3b8;\n\n  --periph-status-text-connected: #34d399;\n\n  --periph-btn-setup-border: #334155;\n  --periph-btn-setup-bg: #1e293b;\n  --periph-btn-setup-text: #cbd5e1;\n  --periph-btn-setup-hover-bg: #334155;\n  --periph-btn-setup-hover-text: #f8fafc;\n\n  --periph-scan-bg: #f8fafc;\n  --periph-scan-text: #0f172a;\n  --periph-scan-hover-bg: #e2e8f0;\n\n  --periph-header-bg: #1e293b;\n  --periph-header-border: #334155;\n}\n\n/* Container & Font */\n.peripherals-page-container {\n  height: calc(100vh - 54px);\n  overflow-y: scroll; /* Force scrollbar */\n  background-color: var(--periph-bg);\n  color: var(--periph-text-primary);\n  font-family:\n    \"Inter\",\n    -apple-system,\n    BlinkMacSystemFont,\n    \"Segoe UI\",\n    Roboto,\n    sans-serif;\n  padding-bottom: 6rem;\n  transition:\n    background-color 0.3s ease,\n    color 0.3s ease;\n  margin-top: 54px;\n  width: 100%;\n}\n\n.peripherals-page-container::-webkit-scrollbar {\n  width: 8px;\n  display: block;\n}\n\n.peripherals-page-container::-webkit-scrollbar-track {\n  background: #f1f1f1;\n}\n\n.peripherals-page-container::-webkit-scrollbar-thumb {\n  background: #c1c1c1;\n  border-radius: 4px;\n}\n\n.peripherals-page-container::-webkit-scrollbar-thumb:hover {\n  background: #a8a8a8;\n}\n\n/* Header */\n.peripherals-header {\n  background-color: var(--periph-header-bg);\n  border-bottom: 1px solid var(--periph-header-border);\n  position: sticky;\n  top: 0;\n  z-index: 100;\n  box-shadow: 0 4px 20px -10px rgba(0, 0, 0, 0.05);\n  transition:\n    background-color 0.3s ease,\n    border-color 0.3s ease;\n}\n\n.peripherals-header-content {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 0 1.5rem;\n  height: 72px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.peripherals-header-left {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n\n.peripherals-back-btn {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  background-color: var(--periph-btn-setup-hover-bg);\n  border: 1px solid var(--periph-border);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  color: #45556c;\n}\n\n.peripherals-back-btn:hover {\n  background-color: var(--periph-border);\n  color: var(--periph-text-primary);\n}\n\n.peripherals-title {\n  font-size: 1.25rem;\n  font-weight: 700;\n  letter-spacing: -0.025em;\n  margin: 0;\n  color: var(--periph-text-primary);\n}\n\n.peripherals-scan-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n  height: 40px;\n  padding: 0 1.25rem;\n  border-radius: 18px;\n  font-size: 0.875rem;\n  font-weight: 600;\n  background-color: var(--periph-scan-bg);\n  color: var(--periph-scan-text);\n  border: none;\n  cursor: pointer;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n  transition: all 0.2s ease;\n}\n\n.peripherals-scan-btn:hover {\n  background-color: var(--periph-scan-hover-bg);\n  transform: translateY(-1px);\n}\n\n.peripherals-scan-btn:active {\n  transform: translateY(0);\n}\n/* Main Content Area */\n.peripherals-main {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 2rem 1.5rem;\n}\n\n.peripherals-category-select-wrapper {\n  display: flex;\n  justify-content: flex-end;\n  margin-bottom: 2rem;\n}\n\n.category-select-wrapper {\n  width: 280px !important;\n}\n\n/* Responsive Card Grid */\n.peripherals-grid {\n  display: grid;\n  grid-template-columns: repeat(1, minmax(0, 1fr));\n  gap: 1.25rem;\n}\n\n@media (min-width: 640px) {\n  .peripherals-grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n}\n\n@media (min-width: 1024px) {\n  .peripherals-grid {\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n  }\n}\n\n@media (min-width: 1280px) {\n  .peripherals-grid {\n    grid-template-columns: repeat(5, minmax(0, 1fr));\n  }\n}\n\n/* Peripherals Cards */\n.peripherals-card {\n  background-color: var(--periph-card-bg);\n  border-radius: 1rem;\n  padding: 1.25rem;\n  border: 1px solid var(--periph-border);\n  box-shadow:\n    0 1px 3px rgba(0, 0, 0, 0.02),\n    0 1px 2px rgba(0, 0, 0, 0.04);\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  min-height: 240px;\n  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.peripherals-card:hover {\n  transform: translateY(-4px);\n  box-shadow:\n    0 10px 20px -5px rgba(0, 0, 0, 0.05),\n    0 4px 6px -2px rgba(0, 0, 0, 0.02);\n}\n\n.peripherals-card.active {\n  border-color: var(--periph-icon-text-connected);\n  box-shadow: 0 0 0 2px var(--periph-icon-bg-connected);\n}\n\n.peripherals-card-top {\n  margin-bottom: 1rem;\n}\n\n.peripherals-card-header-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-bottom: 0.75rem;\n}\n\n.peripherals-icon-box {\n  width: 40px;\n  height: 40px;\n  border-radius: 50px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s ease;\n}\n\n.peripherals-icon-box.connected {\n  background-color: var(--periph-icon-bg-connected);\n  color: var(--periph-icon-text-connected);\n}\n\n.peripherals-icon-box.disconnected {\n  background-color: var(--periph-icon-bg-disconnected);\n  color: var(--periph-icon-text-disconnected);\n}\n\n.peripherals-card-title {\n  font-size: 1rem;\n  font-weight: 700;\n  color: var(--periph-text-primary);\n  margin: 0 0 0.25rem 0;\n  line-height: 1.4;\n}\n\n.peripherals-card-model {\n  font-size: 0.75rem;\n  color: #62748e;\n  margin: 0;\n}\n\n.peripherals-card-bottom {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\n.peripherals-status-row {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.status-icon {\n  width: 1rem;\n  height: 1rem;\n}\n\n.status-icon.connected {\n  color: var(--periph-icon-text-connected);\n}\n\n.status-icon.disconnected {\n  color: var(--periph-text-muted);\n}\n\n.peripherals-status-text {\n  font-size: 0.8125rem;\n  font-weight: 600;\n}\n\n.peripherals-status-text.connected {\n  color: var(--periph-status-text-connected);\n}\n\n.peripherals-status-text.disconnected {\n  color: var(--periph-text-secondary);\n}\n\n.peripherals-last-active {\n  font-size: 0.6875rem;\n  font-weight: 500;\n  color: #90a1b9;\n}\n\n.peripherals-card-actions {\n  border-top: 1px solid var(--periph-border);\n  padding-top: 0.75rem;\n  display: flex;\n  gap: 0.5rem;\n}\n\n.peripherals-setup-btn,\n.peripherals-test-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.375rem;\n  height: 32px;\n  flex: 1;\n  border-radius: 20px;\n  font-size: 0.75rem;\n  font-weight: 600;\n  background-color: var(--periph-btn-setup-bg);\n  border: 1px solid var(--periph-btn-setup-border);\n  color: var(--periph-btn-setup-text);\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.peripherals-setup-btn:hover,\n.peripherals-test-btn:hover {\n  background-color: var(--periph-btn-setup-hover-bg);\n  color: var(--periph-btn-setup-hover-text);\n}\n\n.peripherals-setup-btn svg,\n.peripherals-test-btn svg {\n  color: #62748e;\n  transition: color 0.2s ease;\n}\n\n.peripherals-setup-btn:hover svg,\n.peripherals-test-btn:hover svg {\n  color: var(--periph-btn-setup-hover-text);\n}\n\n.peripherals-setup-btn:disabled,\n.peripherals-test-btn:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n/* ── Setup Modal ── */\n.periph-modal-overlay {\n  position: fixed;\n  inset: 0;\n  background-color: rgba(0, 0, 0, 0.45);\n  z-index: 1300;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 1rem;\n}\n\n.periph-modal {\n  background-color: #ffffff;\n  border-radius: 20px;\n  width: 100%;\n  max-width: 480px;\n  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);\n  overflow: hidden;\n  position: relative;\n  animation: periph-modal-in 0.2s ease;\n}\n\n@keyframes periph-modal-in {\n  from {\n    opacity: 0;\n    transform: scale(0.96) translateY(6px);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1) translateY(0);\n  }\n}\n\n.periph-modal-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 1.25rem 1.5rem 1rem;\n  border-bottom: 1px solid #f1f5f9;\n}\n\n.periph-modal-title {\n  font-size: 1.125rem;\n  font-weight: 700;\n  color: #0f172a;\n  margin: 0;\n  letter-spacing: -0.02em;\n}\n\n.periph-modal-close-btn {\n  width: 32px;\n  height: 32px;\n  border-radius: 8px;\n  border: none;\n  background: transparent;\n  color: #64748b;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition:\n    background-color 0.15s ease,\n    color 0.15s ease;\n}\n\n.periph-modal-close-btn:hover {\n  background-color: #f1f5f9;\n  color: #0f172a;\n}\n\n.periph-modal-body {\n  padding: 1.5rem;\n  display: flex;\n  flex-direction: column;\n  gap: 1.25rem;\n}\n\n.periph-modal-field {\n  display: flex;\n  flex-direction: column;\n  gap: 0.625rem;\n}\n\n.periph-modal-label {\n  font-size: 0.8125rem;\n  font-weight: 600;\n  color: #334155;\n}\n\n/* Connection type buttons */\n.periph-conn-type-grid {\n  display: flex;\n  gap: 0.75rem;\n  flex-wrap: wrap;\n}\n\n.periph-conn-type-btn {\n  flex: 1;\n  min-width: 100px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n  padding: 0.875rem 0.5rem;\n  border-radius: 12px;\n  border: 2px solid #e2e8f0;\n  background-color: #ffffff;\n  color: #64748b;\n  cursor: pointer;\n  transition:\n    border-color 0.15s ease,\n    background-color 0.15s ease,\n    color 0.15s ease;\n}\n\n.periph-conn-type-btn:hover {\n  border-color: #cbd5e1;\n  background-color: #f8fafc;\n}\n\n.periph-conn-type-btn.active {\n  border-color: #2563eb;\n  background-color: #eff6ff;\n  color: #1d4ed8;\n}\n\n.periph-conn-type-btn:disabled {\n  opacity: 0.35;\n  cursor: not-allowed;\n}\n\n.periph-conn-type-label {\n  font-size: 0.75rem;\n  font-weight: 600;\n}\n\n/* Modal action buttons */\n.periph-modal-actions {\n  display: flex;\n  gap: 0.75rem;\n  padding-top: 0.5rem;\n}\n\n.periph-modal-cancel-btn,\n.periph-modal-connect-btn {\n  flex: 1;\n  height: 44px;\n  border-radius: 12px;\n  font-size: 0.875rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition:\n    background-color 0.15s ease,\n    opacity 0.15s ease;\n}\n\n.periph-modal-cancel-btn {\n  border: 1px solid #e2e8f0;\n  background-color: #ffffff;\n  color: #334155;\n}\n\n.periph-modal-cancel-btn:hover {\n  background-color: #f8fafc;\n}\n\n.periph-modal-connect-btn {\n  border: none;\n  background-color: #2563eb;\n  color: #ffffff;\n}\n\n.periph-modal-connect-btn:hover:not(:disabled) {\n  background-color: #1d4ed8;\n}\n\n.periph-modal-connect-btn:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n.periph-view-more-btn {\n  background: none;\n  border: none;\n  color: #2563eb;\n  font-size: 0.8125rem;\n  font-weight: 600;\n  cursor: pointer;\n  padding: 0;\n  display: inline-flex;\n  align-items: center;\n  gap: 0.25rem;\n  transition: color 0.15s ease;\n}\n\n.periph-view-more-btn:hover {\n  color: #1d4ed8;\n  text-decoration: underline;\n}\n\nbody.dark .periph-view-more-btn,\n.dark .periph-view-more-btn {\n  color: #3b82f6;\n}\n\nbody.dark .periph-view-more-btn:hover,\n.dark .periph-view-more-btn:hover {\n  color: #60a5fa;\n}\n\n/* Instructions section within the setup modal */\n.periph-modal-instructions {\n  background-color: #f8fafc;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  padding: 1rem 1.25rem;\n  max-height: 300px;\n  overflow-y: auto;\n}\n\n.periph-modal-instructions-title {\n  font-size: 0.8125rem;\n  font-weight: 700;\n  color: #0f172a;\n  margin: 0 0 0.75rem 0;\n  text-transform: uppercase;\n  letter-spacing: 0.02em;\n}\n\n.periph-modal-instructions-content {\n  font-size: 0.8125rem;\n  color: #475569;\n  line-height: 1.6;\n}\n\n.periph-modal-instructions-content ul {\n  margin: 0;\n  padding-left: 1.25rem;\n}\n\n.periph-modal-instructions-content li {\n  margin-bottom: 0.5rem;\n}\n\n.periph-modal-instructions-content a {\n  color: #2563eb;\n  text-decoration: underline;\n}\n\n.periph-modal-instructions-content img {\n  border-radius: 8px;\n  margin: 0.5rem 0;\n}\n\n/* Advanced Settings Section */\n.periph-adv-settings-box {\n  margin-top: 2.5rem;\n  background-color: var(--periph-card-bg);\n  border-radius: 1.5rem;\n  padding: 2rem;\n  border: 1px solid var(--periph-border);\n  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.03);\n  transition: all 0.3s ease;\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.periph-adv-settings-box * {\n  cursor: not-allowed !important;\n}\n\n.periph-adv-settings-header {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  margin-bottom: 2rem;\n}\n\n.periph-adv-settings-icon-box {\n  padding: 0.5rem;\n  background-color: var(--periph-icon-bg-disconnected);\n  border-radius: 0.5rem;\n  color: #64748b;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.3s ease;\n}\n\nbody.dark .periph-adv-settings-icon-box,\n.dark .periph-adv-settings-icon-box {\n  color: #94a3b8;\n}\n\n.periph-adv-settings-title-container {\n  display: flex;\n  flex-direction: column;\n}\n\n.periph-adv-settings-title {\n  font-size: 1.25rem;\n  font-weight: 700;\n  letter-spacing: -0.025em;\n  color: var(--periph-text-primary);\n  margin: 0;\n}\n\n.periph-adv-settings-subtitle {\n  font-size: 0.875rem;\n  color: #64748b;\n  margin: 0.25rem 0 0 0;\n  transition: color 0.3s ease;\n}\n\nbody.dark .periph-adv-settings-subtitle,\n.dark .periph-adv-settings-subtitle {\n  color: #94a3b8;\n}\n\n.periph-adv-settings-content {\n  max-width: 48rem;\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.periph-adv-settings-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 1.25rem;\n  background-color: var(--periph-bg);\n  border-radius: 1rem;\n  border: 1px solid var(--periph-border);\n  transition: all 0.2s ease;\n}\n\n.periph-adv-settings-row:hover {\n  border-color: #cbd5e1;\n}\n\nbody.dark .periph-adv-settings-row:hover,\n.dark .periph-adv-settings-row:hover {\n  border-color: #475569;\n}\n\n.periph-adv-settings-info {\n  padding-right: 1.5rem;\n}\n\n.periph-adv-settings-item-title {\n  font-size: 0.9375rem;\n  font-weight: 600;\n  color: var(--periph-text-primary);\n  margin: 0;\n}\n\n.periph-adv-settings-item-desc {\n  font-size: 0.8125rem;\n  color: #64748b;\n  margin: 0.25rem 0 0 0;\n  line-height: 1.4;\n  transition: color 0.3s ease;\n}\n\nbody.dark .periph-adv-settings-item-desc,\n.dark .periph-adv-settings-item-desc {\n  color: #94a3b8;\n}\n\n.periph-switch-btn {\n  display: inline-flex;\n  height: 1.25rem;\n  width: 2.25rem;\n  flex-shrink: 0;\n  cursor: pointer;\n  align-items: center;\n  border-radius: 9999px;\n  border: 2px solid transparent;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n  transition: background-color 0.2s ease;\n  background-color: #cbd5e1;\n  position: relative;\n  padding: 0;\n  margin-top: 0.25rem;\n}\n\n.periph-switch-btn[data-state=\"checked\"] {\n  background-color: #2563eb;\n}\n\nbody.dark .periph-switch-btn {\n  background-color: #475569;\n}\n\nbody.dark .periph-switch-btn[data-state=\"checked\"] {\n  background-color: #3b82f6;\n}\n\n.periph-switch-thumb {\n  pointer-events: none;\n  display: block;\n  height: 1rem;\n  width: 1rem;\n  border-radius: 9999px;\n  background-color: #ffffff;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  transition: transform 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n  transform: translateX(0);\n}\n\n/* ── Dark mode: modal surfaces ── */\n.dark .periph-modal {\n  background-color: #1e293b;\n  color: #f1f5f9;\n}\n\n.dark .periph-modal-header {\n  border-bottom-color: #334155;\n}\n\n.dark .periph-modal-title {\n  color: #f1f5f9;\n}\n\n.dark .periph-modal-close-btn {\n  color: #94a3b8;\n}\n\n.dark .periph-modal-close-btn:hover {\n  background-color: #334155;\n  color: #f1f5f9;\n}\n\n.dark .periph-modal-label {\n  color: #94a3b8;\n}\n\n.dark .periph-conn-type-btn {\n  background-color: #1e293b;\n  border-color: #334155;\n  color: #94a3b8;\n}\n\n.dark .periph-conn-type-btn:hover {\n  background-color: #334155;\n  border-color: #475569;\n}\n\n.dark .periph-conn-type-btn.active {\n  background-color: #1e3a5f;\n  border-color: #3b82f6;\n  color: #93c5fd;\n}\n\n.dark .periph-modal-cancel-btn {\n  background-color: #1e293b;\n  border-color: #334155;\n  color: #cbd5e1;\n}\n\n.dark .periph-modal-cancel-btn:hover {\n  background-color: #334155;\n}\n\n.dark .periph-modal-instructions {\n  background-color: #0f172a;\n  border-color: #334155;\n}\n\n.dark .periph-modal-instructions-title {\n  color: #f1f5f9;\n}\n\n.dark .periph-modal-instructions-content {\n  color: #94a3b8;\n}\n\n.periph-switch-thumb[data-state=\"checked\"] {\n  transform: translateX(1rem);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
